module.exports = __webpack_public_path__ + "static/a-story-lately-told-1c57122af701fa09277afa488c56fd16.jpg";